import React from 'react';
import styled from 'styled-components';

const docUrl = 'https://goat-10.gitbook.io/goat-one-piece-user-guide/';

const Wrapper = styled.div`
    position: relative;
    background-color: #121212;
    margin-top: -120px;
    padding-top: 120px;

    iframe {
        width: 100vw;
        height: calc(100vh - 120px);
        border: none;

        ${({ theme }) => theme.mediaWidth.upToSmall`
        height: calc(100vh - 188px);
    `};
    }
`;

const UserGuide = () => {
    return (
        <Wrapper>
            <iframe src={docUrl}></iframe>
        </Wrapper>
    );
};

export default UserGuide;
